import { useMutation } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { AppContext } from '../../AppContext';
import { ROUTES } from '../../common/constants';
import LoaderComponent from '../../components/LoaderComponent';
import useRouter from '../../hooks/useRouter';
import { AppActionType, AppContextType } from '../../types/appContext.type';
import { LOGOUT_USER } from './graphql/queries';

const Logout = () => {
  const { dispatch } = useContext(AppContext) as AppContextType;
  const { navigate } = useRouter();
  const [logout, { loading, error, data }] = useMutation(LOGOUT_USER, {
    onError() {},
  });

  useEffect(() => {
    logout();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <LoaderComponent />;

  if (error) {
    if (error?.graphQLErrors?.length) {
      dispatch({ type: AppActionType.logout });
      window.location.href = ROUTES.LOGIN;
      return null;
    }

    navigate(-1);
    return null;
  }

  if (data) {
    dispatch({ type: AppActionType.logout });
    window.location.href = ROUTES.LOGIN;
    return null;
  }

  return null;
};

export default Logout;
